/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Creating_SegmentsInputs */



/**
* | output |
* | --- |
* | "Creating audio segments..." |
*
* @param {Audio_Description_Export_Status_Creating_SegmentsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_creating_segments = /** @type {((inputs?: Audio_Description_Export_Status_Creating_SegmentsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Creating_SegmentsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Création des segments audio...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiosegmente erstellen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione di segmenti audio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание аудиофрагментов...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando segmentos de audio...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在创建音频片段……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ セグメントを作成しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो सेगमेंट तैयार किए जा रहे हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criando segmentos de áudio...")
	return /** @type {LocalizedString} */ ("Creating audio segments...")
});